import React from "react";
import {connect} from "react-redux";
import styled from 'styled-components';
import filter from "lodash/filter";
import get from "lodash/get";

import { setHeaderTitle } from "../../store/action";
import { cutString } from "../../util/cutString";
import config from "../../Config";
import i18n from "../../i18n";

const Header = styled.div`
	height: 120px;
	display: flex;
    justify-content: center;
    align-items: center;
`;

const Card = styled.div`
	height: 100px;
	background-color: #fff;
	padding: 5px 20px;
	display: flex;
    align-items: center;
    border-bottom: 1px solid #F1F1F1;
`;

const Profile = styled.div`
	flex: 1;
`;

const Details = styled.div`
	flex: 2.5;
`;

const Product = styled.div`
	flex: 1.5;
	display: flex;
	flex-direction: column;
	text-align: center;
`;

const UserName = styled.span`
	font-size: 16px;
	font-family: montserratRegular;
`;

const BidDetails = styled.div`
	font-size: 14px;
	font-family: montserratLight;
	margin-top: 5px;
	margin-bottom: 5px;
`;

const BidValue = styled.span`
	color: #f32c2c;
	font-weight: 600;
`;

const State = styled.span`
	font-size: 14px;
	font-family: montserratLight;
`;

class PastWinners extends React.Component{

	componentWillMount(){
		this.props.setHeaderTitle(i18n.t("Winners"));
	}
	
	render(){
		const { data } = this.props;
		console.log("PastWinners -->>",data);
        if (!data) {
            return null;
        } else if (data.error) {
            return <span>{data.error}</span>
        }

        const auctions = filter(data,{ auctionStatus: "INACTIVE" });
		return <div className="container_56">
			<Header>
				<img src={`${config.MRBIDNWIN_S3_IMAGE_URL}/trophy.svg`} alt="trophy"/>
			</Header>
			{
				auctions.map((el,index)=>{

					return <Card key={el.offerId}>
						<Profile>
							<div className="flex-center profile_circle">
								<img style={{width:50,height:50,borderRadius:'50%'}}  src={get(el, "winnerDetailsDto.userImageUrl", `${config.MRBIDNWIN_S3_IMAGE_URL}/small_user_avatar.svg`)} alt="winner-profile"/>
							</div>
						</Profile>
						<Details>
							<UserName>{cutString(get(el, "winnerDetailsDto.username", ""), 20)}</UserName>
							<BidDetails>
								<span>Winning Bid:</span> <BidValue>{get(el, "winnerDetailsDto.bidValue", "")}</BidValue>
							</BidDetails>
							<State>{cutString(get(el ,"winnerDetailsDto.city", ""), 20)}</State>
						</Details>
						<Product>
							<div>
								<img width="45px" height="65px" src={el.offerImageUrl} alt={el.offerTitle}/>
							</div>
							<State>{cutString(el.offerTitle, 15)}</State>
						</Product>
					</Card>
				})
			}
		</div>
	}
}

export default PastWinners = connect((state, ownProps) => {
    return { data: get(state, "data.homeData.auctionDetailsDTO.auction") };
}, {
    setHeaderTitle
})(PastWinners);



// WEBPACK FOOTER //
// ./src/views/PastWinners/index.js